// FIXME: border color should follow theme
export const border = {
    borderRight: '0.5px solid #303237',
};
